import {
    GET_KNOWLEDGE_CATEGORIES,
    GET_KNOWLEDGE_FILES,
    SET_KNOWLEDGE_ERROR,
    SET_KNOWLEDGE_LOADING,
} from "../../../../enums/KnowledgeBase/knowledgeBase";

export const setKnowledgeCategoriesAction = (data) => ({
    type: GET_KNOWLEDGE_CATEGORIES,
    payload: data,
});

export const setKnowledgeFilesAction = (type, data) => ({
    type: GET_KNOWLEDGE_FILES,
    payload: { type, data },
});

export const setKnowledgeLoadingAction = (loading) => ({
    type: SET_KNOWLEDGE_LOADING,
    payload: loading,
});

export const setKnowledgeErrorAction = (error) => ({
    type: SET_KNOWLEDGE_ERROR,
    payload: error,
});